type Props = {
  className?: string
}

export const IconCurrentLocation = ({ className }: Props) => {
  return (
    <svg
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill="white" height="24" width="24" />
      <path
        d="M4.875 11.625L19.125 4.875L12.375 19.125L10.875 13.125L4.875 11.625Z"
        fill="#404040"
        stroke="#404040"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
